<template>
	<div>
		<botao-tooltip
			id="botao-visualizar"
			icone="mdi-eye"
			v-if="!penalidadePedido"
			v-az-auth="permissoes.ataPenalidadesVisualizar"
			cor="grey"
			texto="Visualizar"
			@click="$emit('visualizar', item)"
		></botao-tooltip>
		<botao-tooltip
			id="botao-editar"
			icone="mdi-pencil"
			v-if="podeExibirAcao(item.usuarioPodeEditar)"
			v-az-auth="permissoes.ataPenalidadesEditar"
			cor="grey"
			texto="Editar"
			@click="$emit('editar', item)"
		></botao-tooltip>
		<botao-tooltip
			id="botao-excluir"
			icone="mdi-delete"
			v-if="!item.ehSancao && podeExibirAcao(item.usuarioPodeExcluir)"
			v-az-auth="permissoes.ataPenalidadesExcluir"
			cor="grey"
			texto="Excluir"
			@click="$emit('excluir', item)"
		></botao-tooltip>
		<botao-tooltip
			id="botao-historico-notificacoes"
			icone="mdi-history"
			v-if="(usuarioEhGestor || item.usuarioPodeVisualizarHistoricoNotificacoes) && item.possuiInfracao"
			v-az-auth="permissoes.ataPenalidadesHistoricoNotificacoes"
			cor="grey"
			texto="Histórico de Notificações"
			@click="$emit('historico-notificacoes', item)"
		></botao-tooltip>
	</div>
</template>

<script>
import permissoesMixin from '@/views/mixins/permissoes-mixin'
import BotaoTooltip from '@/views/components/BotaoTooltip.vue'
import TipoPenalidade from '@/core/constants/tipo-penalidade'

export default {
	name: 'listagem-penalidades-botoes-acoes',
	components: { BotaoTooltip },
	mixins: [permissoesMixin],
	props: {
		item: {
			type: Object,
			required: true,
		},
		usuarioEhGestor: {
			type: Boolean,
			required: true,
		},
	},
	computed: {
		penalidadePedido() {
			return TipoPenalidade.PEDIDO_UTILIZACAO.value === this.item.tipoEntidade
		},
	},
	methods: {
		podeExibirAcao(validacaoUsuario) {
			if (this.penalidadePedido) return false

			return this.usuarioEhGestor || validacaoUsuario
		},
	},
}
</script>

<style scoped lang="stylus">
.justify-content-center
	justify-content center
</style>
